import { AuthService } from '@1bill-app/services/auth/state/auth.service';
import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.page.html',
  styleUrls: ['./verification.page.scss'],
})
export class VerificationPage implements OnInit, AfterViewInit {
  isVerifying: boolean;
  isVerified: boolean;
  isAlreadyVerified: boolean;
  isVerificationError: boolean;
  constructor(
    private rotue: ActivatedRoute,
    private authService: AuthService,
    private logger: NGXLogger,
  ) {}

  ngOnInit() {}
  ngAfterViewInit() {
    this.processVerification();
  }

  async processVerification() {
    this.isVerifying = true;
    try {
      const code = this.rotue.snapshot.queryParamMap.get('verification_code');
      const encodedData = this.rotue.snapshot.queryParamMap.get('verification_data');
      if (!code || !encodedData) {
        this.isVerificationError = true;
        this.isVerifying = false;
        return;
      }
      const decodedData = JSON.parse(atob(encodedData));
      const { userName } = decodedData;
      // wait 400ms
      await new Promise<void>((resolve) => setTimeout(() => resolve(), 400));
      // confirm signup
      await this.authService.confirmSignUp(userName, code, false).toPromise();
      this.isVerified = true;
    } catch (err) {
      if (err.message && err.message.includes('Current status is CONFIRMED')) {
        this.isAlreadyVerified = true;
      } else {
        this.isVerificationError = true;
      }
      this.logger.error('processVerification',err);
    }
    this.isVerifying = false;
    return;
  }
}
